<template>
  <div class="rate-table one" :class="[{ look: mode=='base' },'showNum'+(cssNum-1)]">
    <div class="head">
      <div class="td first-td">
        <div class="name-key">险种名称</div>
      </div>
      <div class="td">方案名称</div>
      <div class="td" v-for="(item, i) in headList" :key="i">{{item.name}}</div>
      <div class="td" v-if="showFold">公司折标系数(%)</div>
      <div class="td" v-if="mode!='base'||type==2">服务费分配</div>
      <div class="td">首年(%)</div>
      <div class="td" v-if="data.isDynamicRate">首年发放(%)</div>
      <div class="td" v-if="data.isDynamicRate">首年后置(%)</div>
      <div class="td" v-if="data.activityInfoVO&&(type==2||(userType==2&&mode=='base'))"><i class="huo">活</i>首年活动(%)</div>
      <div class="td" v-if="data.activityInfoVO&&mode=='base'"><i class="huo">活</i>业务员首年活动(%)</div>
      <!-- 历史费率展示 -->
      <div class="td" v-for="(item, i) in activityList" :key="'act'+i">
        <i class="huo">活</i>首年活动
        <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" :transfer="true">
          <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" />
          <div slot="content">
            <p>活动名称：{{item.name}}</p>
            <p>活动时间：{{item.startTime}}至{{item.endTime}}</p>
          </div>
        </Poptip>
      </div>
      <!-- 第2年及后面的 -->
      <div class="td" v-for="bean in yearList" :key="'year'+bean.index">
        {{ bean.text }}
        <span v-if="data.untilLastCommissionIndex>0&&bean.index==showNum&&bean.index>5">至交费期满(%)</span>
        <span v-else>(%)</span>
      </div>
      <!-- <div class="td last-td big-td" v-if="mode!='base'&&organShow">操作</div> -->
    </div>
    <div class="body">
      <div class="empty-text" v-if="!dataBak.commissionItems || dataBak.commissionItems.length == 0"> <slot name="emptyText">暂无数据</slot></div>
      <div class="row-child" v-for="(item, x) in dataBak.commissionItems" :key="x">
        <div class="td first-td">
          <div class="productName-box">
            <div class="tag fu" v-if="item.isMain === '0'">附</div>
            {{ item.productName }}
          </div>
        </div>
        <div class="row-box">
          <div class="row-child" :class="{'top-row':mode!='base'}" v-for="(item2, ii) in item.programBaseList" :key="ii">
            <div class="td full-td">{{ item2.name }}</div>
            <div class="td full-td" v-for="(head, iii) in headList" :key="iii">
              <tooltip :txtInfo="getKeyText(item2.factors,head.code)" v-if="getKeyText(item2.factors,head.code).length>30"></tooltip>
              <span v-else>{{getKeyText(item2.factors,head.code)}}</span>
            </div>
            <div class="row-box" v-if="type == 1 || type == 0 || mode=='base'">
              <div class="row-child" v-for="(item4, iiii) in item2.agencyList" :key="iiii" :class="{ hide: iiii == 2 && type == 0 }">
                <template v-if="mode!='base'">
                  <div class="td" v-if="iiii == 0 && (type == 0 || mode=='base')">
                    基准费率
                  </div>
                  <div class="td" v-if="iiii == 1 && type == 0">商户</div>
                  <div class="td" v-if="iiii == 0 && type == 1">
                    上级机构
                  </div>
                  <div class="td" v-if="iiii == 1 && type == 1">
                    应用机构
                  </div>
                  <div class="td" v-if="iiii == 2 && type == 1">
                    上级剩余
                  </div>
                </template>
                <!-- 折标 -->
                <div class="td" v-if="showFold">{{item4.fold ? item4.fold.value : '-'}}</div>
                <!-- 首年 -->
                <rateTableItem :list="item2.agencyList" listKey="agencyList" :item="item4"
                  dataKey="0" :mode="mode" :edit="item.edit" :index="iiii"></rateTableItem>
                <template v-if="data.isDynamicRate">
                  <!-- 首年发放 -->
                  <rateTableItem :list="item2.agencyList" listKey="agencyList" :item="item4"
                    dataKey="0" :mode="mode" :edit="item.edit" :index="iiii" valueKey="afterPostfRateValue"></rateTableItem>
                  <!-- 首年后置 -->
                  <rateTableItem :list="item2.agencyList" listKey="agencyList" :item="item4"
                    dataKey="0" :mode="mode" :edit="item.edit" :index="iiii" valueKey="postfRateValue"></rateTableItem>
                </template>
                <!-- 历史费率活动展示 -->
                <div class="td" v-for="(item, i) in activityList" :key="'act'+i">
                  {{getActivityNum(item4.agencyActs, item)}}
                </div>
                <!-- 商户活动 只在商品库中显示 -->
                <div class="td" v-if="data.activityInfoVO&&userType==2&&mode=='base'">{{item4.merAct ? item4.merAct.value : '-'}}</div>
                <!-- 业务员活动 只在商品库中显示 -->
                <div class="td" v-if="data.activityInfoVO&&mode=='base'&&pageType!='productLibrary'&&pageType!='merchant'">{{item4.agencyAct ? item4.agencyAct.value : '-'}}</div>
                <!-- 第二年及后面 -->
                <rateTableItem
                  v-show="i5!=0"
                  v-for="(bean,i5) in item4.commissionInfoBeans"
                  :key="'item'+i5"
                  :list="item2.agencyList"
                  listKey="agencyList"
                  :dataKey="i5"
                  :mode="mode"
                  :edit="item.edit"
                  :index="iiii"
                ></rateTableItem>
              </div>
            </div>
            <div class="row-box" v-else>
              <div class="row-child" v-for="(item4, iiii) in item2.groupList" :key="iiii">
                <div class="td" v-if="iiii == 0 && mode!='base'">所属机构</div>
                <div class="td" v-if="(iiii == 1 && mode!='base') || (iiii == 0 && mode=='base')">团队长</div>
                <div class="td" v-if="(iiii == 2 && mode!='base') || (iiii == 1 && mode=='base')">团员</div>
                <div class="td" v-if="iiii == 3 && mode!='base'">机构剩余</div>
                <!-- 首年 -->
                <rateTableItem :list="item2.groupList" listKey="groupList"
                  dataKey="0" :mode="mode" :edit="item.edit" :index="iiii"></rateTableItem>
                  <template v-if="data.isDynamicRate">
                  <!-- 首年发放 -->
                  <rateTableItem :list="item2.groupList" listKey="groupList"
                    dataKey="0" :mode="mode" :edit="item.edit" :index="iiii" valueKey="afterPostfRateValue"></rateTableItem>
                  <!-- 首年后置 -->
                  <rateTableItem :list="item2.groupList" listKey="groupList"
                    dataKey="0" :mode="mode" :edit="item.edit" :index="iiii" valueKey="postfRateValue"></rateTableItem>
                </template>
                <!-- 活动 -->
                <div class="td" v-if="data.activityInfoVO&&component!='commissionTemplate'">{{item4.agencyAct ? item4.agencyAct.value : '-'}}</div>
                <!-- 历史费率活动展示 -->
                <div class="td" v-for="(item, i) in activityList" :key="'act'+i">
                  {{getActivityNum(item4.agencyActs, item)}}
                </div>
                <!-- 第二年及后面 -->
                <rateTableItem
                  v-show="i5!=0"
                  v-for="(bean,i5) in item4.commissionInfoBeans"
                  :key="'item'+i5"
                  :list="item2.groupList"
                  listKey="groupList"
                  :dataKey="i5"
                  :mode="mode"
                  :edit="item.edit"
                  :index="iiii"
                ></rateTableItem>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="td full-td last-td btn-td big-td start-td" v-if="mode!='base'&&organShow">
          <div class="btn" v-if="!item.edit" @click="editItem(item)">
            编辑
          </div>
          <div class="btn" v-if="item.edit" @click="save()">保存</div>
          <div class="btn" v-if="item.edit" @click="cancel(item)">取消</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import tooltip from '@/components/commons/tooltip'
import rateTableItem from './rateTableItem'
export default {
  components: { tooltip,rateTableItem },
  props: {
    data: null,
    type: null,
    mode: null, //模式 one 单产品费率 其他 费率模板
    showFold:null,//是否展示折标系数列
    sort:{ //是否允许排序
      type: Boolean,
      default: false
    },
    pageType: null,
    component:null,
  },
  data() {
    return {
      userType:'',//用户类型1、运营 2、商户 3、下级机构 4、业务员
      showNum: 5,
      yearList: [],
      cssNum: 5,
      disabledAll: false,
      isAll: false,
      dataBak: {}, // 备份 对比数据用 当前绑定数据
      dataBak2: {}, // 备份 对比数据用
      headList: [],
      activityList: [],
      list: []
    };
  },
  watch: {
    data() {
      const curData = JSON.parse(JSON.stringify(this.data));
      // 处理原始数据
      const listKey = this.type == 0 || this.type == 1 ? 'agencyList' : 'groupList';
      curData.commissionItems.forEach(item => {
        item.programBaseList.forEach(item2 => {
          item2[listKey].forEach(item3 => {
            let commssionList = item3.commissionInfoBeans;
            if (commssionList && commssionList.length) {
              commssionList = commssionList.sort((a, b) => {
                return a.commissionIndex > b.commissionIndex ? 1 : -1;
              });
              item3.commissionInfoBeans = commssionList;
            }
          });
        });
      });
      this.dataBak = curData;
      this.dataBak2 = JSON.parse(JSON.stringify(curData));
      if (!this.dataBak.commissionItems) {
        return;
      }
      this.headList = this.data.programRules;
      this.activityList = this.data.acInfo;
      this.disabledAll = false;
      this.showNum = this.dataBak.commissionNum;
      if (this.dataBak.programRules) {
        this.cssNum = this.dataBak.programRules.length + this.showNum;
      } else {
        this.cssNum = this.showNum;
      }
      if (this.data.isDynamicRate) {
        this.cssNum += 2;
      }
      this.yearList = [];
      for (let index = 2; index <= this.showNum; index++) {
        this.yearList.push({
          text: '第' + this.$units.numberTransform(index) + '年',
          index
        });
      }
      this.isAll = false;
    }
  },
  computed: {},
  created(){
    this.userType = JSON.parse(localStorage.getItem("userInfo")).userType;
  },
  methods: {
    getActivityNum(list, data){
      if(list) {
        list = JSON.parse(list);
        const bean = list.find(item=>item.id == data.id);
        return (bean&&bean.value*1)?bean.value:'-';
      }else{
        return '-'
      }
    },
    // 获取方案文本
    getKeyText(list, code) {
      const data = list.find((item) => {
        return item.roleCode == code
      })
      if (data && data.remark) {
        return data.remark
      } else {
        return '-'
      }
    },
    // 保存修改
    save() {
      const data1 = this.saveData(JSON.parse(JSON.stringify(this.dataBak)));
      const data2 = this.saveData(JSON.parse(JSON.stringify(this.dataBak2)));
      if(JSON.stringify(data1) != JSON.stringify(data2)){
        this.$emit('save', data1)
      } else {
        this.hideEdit();
      }
    },
    saveData(data) {
      const arr = []
      data.commissionItems.forEach((bean) => {
        bean.programBaseList.forEach((item2) => {
          if(this.mode=='base'){
            const list = item2.agencyList
            this.pushData(arr, list[0], list)
          } else if (this.type == 1 || this.type == 0) {
            const list = item2.agencyList
            this.pushData(arr, list[1], list)
          } else {
            const list = item2.groupList
            this.pushData(arr, list[1], list)
            this.pushData(arr, list[2], list)
          }
        })
      })
      return {list: arr, productCode: data.productCode};
    },
    // 合成提交数据
    pushData(arr, bean, parentList) {
      bean.commissionInfoBeans.forEach((item,i)=>{
        const parent = parentList[0]['commissionInfoBeans'][i]
        if(parent){
          item.parentValue = parent.value;
          if(this.pageType=='merchant'&&this.dataBak.isArbitrageSpace==1){
            item.parentArbitrageSpacePostfRateValue = parent.arbitrageSpacePostfRateValue;
          }
        }
        this.defaultData(arr, item);
      });
    },
    // 处理空值
    defaultData(arr, data) {
      if (data.value == '') {
        data.value = 0
      }
      arr.push(data)
    },
    // 选中事件
    selectChange() {
      const selectArr = []
      let isLongOrShort = [false, false]
      this.dataBak.forEach((item) => {
        if (item.select) {
          //是否选中
          selectArr.push(item.productCode)
          if (item.productType == 1) {
            isLongOrShort[0] = true
          } else {
            isLongOrShort[1] = true
          }
        }
      })
      this.$emit('onSelectChange', selectArr, isLongOrShort)
    },
    // 显示编辑框 外部调用
    showEdit(){
      this.dataBak.commissionItems.forEach((item)=>{
        this.$set(item, 'edit', true);
      })
    },
    // 隐藏编辑框 外部调用
    hideEdit(){
      this.dataBak.commissionItems.forEach((item)=>{
        this.$set(item, 'edit', false);
      })
      this.dataBak = JSON.parse(JSON.stringify(this.data))
      this.$emit('hideEdit');
    },
    cancel(item) {
      this.$set(item, 'edit', false)
      this.dataBak = JSON.parse(JSON.stringify(this.data))
    },
    swapItems(index1, index2,type,secIndex) {
      if(type == 1){
        this.dataBak.commissionItems[index1] = this.dataBak.commissionItems.splice(index2, 1, this.dataBak.commissionItems[index1])[0]
      }else {
        this.dataBak.commissionItems[index1].programBaseList[secIndex] = this.dataBak.commissionItems[index1].programBaseList.splice(index2, 1,  this.dataBak.commissionItems[index1].programBaseList[secIndex])[0]
      }
      this.saveSort()
    },
    //type 1 险种排序 2 方案排序
    upData(type,index,secIndex = 0) {
      this.swapItems(index,type == 1? index - 1:secIndex - 1,type,secIndex)
    },
    downData(type,index,secIndex = 0) {
      this.swapItems(index, type == 1? index + 1:secIndex + 1,type,secIndex)
    },
    saveSort(){
      const arr = []
      const data = JSON.parse(JSON.stringify(this.dataBak))
      data.commissionItems.forEach((bean) => {
        bean.programBaseList.forEach((item2) => {
          if(this.mode=='base'){
            const list = item2.agencyList
            this.pushData(arr, list[0], list)
          } else if (this.type == 1 || this.type == 0) {
            const list = item2.agencyList
            this.pushData(arr, list[1], list)
          } else {
            const list = item2.groupList
            this.pushData(arr, list[1], list)
            this.pushData(arr, list[2], list)
          }
        })
      })
      this.$emit('changeSort', { list: arr, productCode: data.productCode })
    },
  },
}
</script>
<style lang="scss" scoped>
@import './rateTable.scss';
</style>